<template>
  <q-select
    :label="label"
    v-model="selectedOption"
    :options="renderedOptions"
    @filter="filterOptions"
    option-value="value"
    option-label="label"
    use-input
    hide-selected
    fill-input
    map-options
    outlined
    dense
    input-debounce="0"
    :behavior="$q.platform.is.ios === true ? 'dialog' : 'menu'"
    ref="componentReference"
    class="qSelect"
    :popup-content-style="selectInputHeight(renderedOptions)"
  >
    <template v-slot:append>
      <q-icon
        v-if="clearable"
        class="cursor-pointer"
        name="cancel"
        @click.stop.prevent="$emit('clearSelected')"
      />
    </template>
  </q-select>
</template>

<script>
import { computed, ref } from 'vue'
import { stringToSlug } from 'src/utils/stringToSlug'

export default {
  name: 'swFilterableSelect',
  props: {
    label: { type: String },
    value: { type: Object },
    options: { type: Array },
    clearable: { type: Boolean }
  },
  emits: ['clearSelected'],
  setup(props, { emit }) {
    let selectedOption = computed({
      get() {
        return props.value
      },
      set(value) {
        emit('input', value)
        hideOptionsPopup()
      }
    })

    const options = ref(null)

    const renderedOptions = computed({
      get() {
        return options.value ?? props.options
      },
      set(value) {
        options.value = value
      }
    })

    let componentReference = ref(null)

    const hideOptionsPopup = () => {
      componentReference.value.blur()
    }

    const filterOptions = (val, update) => {
      update(() => {
        renderedOptions.value = props.options.filter((option) => {
          return stringToSlug(option.label).includes(stringToSlug(val))
        })
      })
    }


    const selectInputHeight = (options) => {
      return options.length > 3 ? { height: '150px' } : undefined
    }

    return {
      selectedOption,
      componentReference,
      renderedOptions,
      filterOptions,
      hideOptionsPopup,
      selectInputHeight
    }
  }
}
</script>
<style scoped>
.qSelect {
  width: 100%;
}
</style>
